import IPerson from "../models/people/IPerson";
import networkService from "./networkService";

class PeopleService {

    async getPeople() : Promise<IPerson[]> {
        const result = await networkService.get<IPerson[]>("people");

        if (result.isSuccessful) {
            return result.data as IPerson[];
        }

        throw result.data;
    }

    async getPerson(id: string) : Promise<IPerson> {
        const result = await networkService.get<IPerson>(`people/${id}`);

        if (result.isSuccessful) {
            return result.data as IPerson;
        }

        throw result.data;
    }
}

const peopleService = new PeopleService();
export default peopleService;